import React from "react";
import styled from "styled-components";
import HoverToolTip from "./HooverTooltip";
import DialogTooltip from "./DialogTooltip";
import media from "@/styles/mediaQueries";

type ResponsiveTooltipProps = {
  trigger: React.ReactElement;
  content: string;
  title?: string;
  className?: string;
  placement?: "top" | "bottom" | "left" | "right";
};

const MobileTooltipContainer = styled.span`
  vertical-align: middle;
  ${media.screenMdMin({
    display: "none",
  })}
`;

const DesktopTooltipContainer = styled.span`
  display: none;
  vertical-align: middle;
  position: relative;
  z-index: 1;
  ${media.screenMdMin({
    display: "inline-flex",
    alignItems: "center",
  })}
`;

const ResponsiveTooltip: React.FC<ResponsiveTooltipProps> = ({
  trigger,
  content,
  title,
  className,
  placement = "top",
}) => {
  return (
    <>
      {/* Mobile: Show DialogTooltip */}
      <MobileTooltipContainer>
        <DialogTooltip
          trigger={trigger}
          content={content}
          title={title}
          className={className}
        />
      </MobileTooltipContainer>

      {/* Desktop: Show HoverTooltip */}
      <DesktopTooltipContainer>
        <HoverToolTip
          trigger={trigger}
          content={content}
          title={title}
          placement={placement}
          className={className}
        />
      </DesktopTooltipContainer>
    </>
  );
};

export default ResponsiveTooltip;
